<div class="app-dialog app-dialog--form">
  <div class="app-dialog__hero">
    <div class="app-dialog__icon" aria-hidden="true">📅</div>
    <div class="app-dialog__heading">
      <h2 class="app-dialog__title">Add Leave</h2>
      <p class="app-dialog__subtitle">Record leave details and keep your balance up to date.</p>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-dialog-content class="app-dialog__content">
      <section class="form-section">
        <h3 class="form-section__label">Leave details</h3>

        <div class="form-grid form-grid--2">
          <mat-form-field appearance="outline">
            <mat-label>Employer</mat-label>
            <mat-select formControlName="employer" [panelClass]="overlayPanelClass">
              <mat-option *ngFor="let e of employers$ | async" [value]="e.id">
                {{ e.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Leave Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="leaveDate">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker [panelClass]="overlayPanelClass"></mat-datepicker>
          </mat-form-field>
        </div>
      </section>

      <section class="form-section">
        <h3 class="form-section__label">Duration & balance</h3>

        <div class="form-grid form-grid--2">
          <mat-form-field appearance="outline">
            <mat-label>Days</mat-label>
            <input matInput type="number" min="1" formControlName="days">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Balance</mat-label>
            <input matInput type="number" formControlName="currentBalance">
          </mat-form-field>
        </div>
      </section>

      <section class="form-section">
        <h3 class="form-section__label">Notes</h3>

        <div class="form-grid form-grid--1">
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput rows="3" formControlName="description"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Note</mat-label>
            <textarea matInput rows="2" formControlName="note"></textarea>
          </mat-form-field>
        </div>
      </section>
    </mat-dialog-content>

    <mat-dialog-actions class="app-dialog__actions" align="end">
      <button mat-stroked-button type="button" (click)="close()">
        Cancel
      </button>
      <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
        Save Leave
      </button>
    </mat-dialog-actions>
  </form>
</div>
